import { createApp } from 'vue';
import { useToast } from 'vue-toastification';
// import VueCookies from 'vue3-cookies';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import axios from 'axios';
import SiteModal from './components/utility/siteModal/SiteModal.vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import ToastNotification from './components/utility/toastNotification/ToastNotification.vue';
import messageHubPlugin from '../public/js/hubs/messageHubPlugin';
import violationReportHubPlugin from '../public/js/hubs/violationReportHubPlugin';
import emergencyRequestHubPlugin from '../public/js/hubs/emergencyRequestHubPlugin';
import Sticky from 'vue3-sticky-directive';

axios.defaults.baseURL = store.state.apiBaseURL;
axios.defaults.withCredentials = true;
axios.defaults.headers.common = {
  Authorization: `Bearer ${store.getters.userToken}`,
};
var requestCount = 0;
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error.config;
    if (error.response.status === 401) {
      if (
        // localStorage.getItem('token') &&
        // localStorage.getItem('refreshToken')
        // eslint-disable-next-line
        getCookie('token') &&
        // eslint-disable-next-line
        getCookie('refreshToken')
      ) {
        // برای جلوگیری از درخواست های multi Thread
        requestCount++;
        if (requestCount > 1) {
          originalConfig._isntFirstTime = true;

          originalConfig.headers['Authorization'] =
            // eslint-disable-next-line
            'Bearer ' + getCookie('token');
          // 'Bearer ' + localStorage.getItem('token');

          return axios.request(originalConfig);
        }
        // متد برای درخواست توکن جدید
        if (requestCount == 1 && !originalConfig._isntFirstTime) {
          // alert(originalConfig.url);
          await store.dispatch('refreshToken');
        }
        // اگر سرور توکن جدید نداد در متد بالا
        // if (!localStorage.getItem('token')) {
        // eslint-disable-next-line
        if (!getCookie('token')) {
          router.push({ name: 'home' }).then(() => {
            window.location.reload();
          });
        }
        // originalConfig.headers['Authorization'] =
        //   'Bearer ' + localStorage.getItem('token');
        else
          originalConfig.headers['Authorization'] =
            // eslint-disable-next-line
            'Bearer ' + getCookie('token');

        setTimeout(function () {
          requestCount = 0;
        }, 10000);

        return axios.request(originalConfig);
      } else
        router.push({ name: 'home' }).then(() => {
          window.location.reload();
        });
    } else if (error.response.status === 404) {
      router.push('/notFound');
    } else if (error.response.status === 403) {
      if (!window.location.href.includes('login')) router.push('/unauthorize');
      else {
        return Promise.reject(error);
      }
    } else if (error.response.status === 429) {
      const toast = useToast();
      toast.error(
        'تعداد درخواست های ارسالی بیش از حد مجاز است. پس از گذشت زمان لازم دوباره تلاش کنید',
        {
          timeout: 3000,
          position: 'bottom-left',
        }
      );
      return Promise.reject(error);
    } else return Promise.reject(error);
  }
);

export default axios;
createApp(App)
  .use(store)
  .use(router)
  .use(messageHubPlugin)
  .use(violationReportHubPlugin)
  .use(emergencyRequestHubPlugin)
  .use(Sticky)
  // .use(VueCookies, {
  //   expireTimes: '30d',
  //   path: '/',
  //   domain: '',
  //   secure: true,
  //   sameSite: 'None',
  // })
  .use(Toast, { transition: 'Vue-Toastification__bounce', timeout: 5000 })
  .component('site-modal', SiteModal)
  .component('toast-notification', ToastNotification)
  .mount('#app');
